/**************************************************
 * Nombre:       Tarjeta_Boton_Nuevo_Ahorro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {Savings} from "@mui/icons-material"

const Tarjeta_Boton_Nuevo_Ahorro = ({alto = 212, click}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            onClick={() => click()}
            sx={{
                border: 2,
                borderColor: '#00000050',
                borderStyle: 'dashed',
                p: 2,
                borderRadius: 4,
                color: '#000',
                minHeight: alto,
                cursor: 'pointer',
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Savings sx={{width: '30%', height: 'auto', fill: '#00000050'}}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{textAlign: 'center', fontWeight: 800, fontSize: 24, color: '#00000050'}}>Crear
                            Nuevo Ahorro</Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Boton_Nuevo_Ahorro